import {
  MQ_SMALL_ONLY,
  MQ_LARGE,
  MQ_XLARGE,
  MQ_MEDIUM
} from 'constants/mq';
import IMAGE_SIZES from 'constants/imageSizes';

const { large4x5, medium4x5, small4x5 } = IMAGE_SIZES;

// default dimensions and options for all stream bundle variants
const base = {
  fallbackDims: medium4x5,
  sourceSets: [
    {
      media: MQ_XLARGE,
      imageDims: large4x5, // max image size we want
      layoutWidth: { value: 312, units: 'px' } // physical dims in page at 1x
    },
    {
      media: MQ_LARGE,
      imageDims: medium4x5,
      layoutWidth: { value: 226, units: 'px' }
    },
    {
      media: MQ_MEDIUM,
      imageDims: small4x5,
      layoutWidth: { value: 25, units: 'vw' }
    },
    {
      media: MQ_SMALL_ONLY,
      imageDims: medium4x5,
      layoutWidth: { value: 50, units: 'vw' }
    }
  ]
};

const exceptionPatterns = undefined;

export default {
  base,
  exceptionPatterns
};
